import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';
import { config } from '../config';

const SOCKET_URL = config.socketUrl;

export const useSocket = () => {
  const socketRef = useRef<Socket | null>(null);
  const { token } = useAuth();

  useEffect(() => {
    if (token) {
      socketRef.current = io(SOCKET_URL, {
        auth: { token }
      });

      return () => {
        socketRef.current?.disconnect();
      };
    }
  }, [token]);

  const joinInvoice = (invoiceId: number) => {
    socketRef.current?.emit('join-invoice', invoiceId.toString());
  };

  const leaveInvoice = (invoiceId: number) => {
    socketRef.current?.emit('leave-invoice', invoiceId.toString());
  };

  const emitInvoiceUpdate = (invoiceId: number) => {
    socketRef.current?.emit('invoice-updated', { invoiceId: invoiceId.toString() });
  };

  const emitNewComment = (invoiceId: number, comment: any) => {
    socketRef.current?.emit('comment-added', { invoiceId: invoiceId.toString(), comment });
  };

  const onInvoiceRefresh = (callback: (data: any) => void) => {
    socketRef.current?.on('invoice-refresh', callback);
    return () => socketRef.current?.off('invoice-refresh', callback);
  };

  const onNewComment = (callback: (comment: any) => void) => {
    socketRef.current?.on('new-comment', callback);
    return () => socketRef.current?.off('new-comment', callback);
  };

  return {
    socket: socketRef.current,
    joinInvoice,
    leaveInvoice,
    emitInvoiceUpdate,
    emitNewComment,
    onInvoiceRefresh,
    onNewComment
  };
};
